const getCopyright = () => {
  const year = new Date().getFullYear();
  return `© ${year}, Natomas Labs, Inc., All rights reserved.`;
};

export default getCopyright;
